import { API_CALL } from '../../../middleware/api';

const root = 'portal/files/device_instruction_videos';
export const DEVICE_INSTRUCTION_VIDEO_PURPOSE = 'device_instruction_video';
const targetPath = orgId => (orgId ? `organizations/${orgId}` : 'global');

export const GET_DEVICE_INSTRUCTION_CONFIGURATION = 'get-device-instruction-configuration';
export const SET_DEVICE_INSTRUCTION_CONFIGURATION = 'set-device-instruction-configuration';
export const RESET_DEVICE_INSTRUCTION_CONFIGURATION = 'reset-device-instruction-configuration';
export const PREVIEW_DEVICE_INSTRUCTION = 'preview-device-instruction';
export const SEARCH_DEVICE_MODELS = 'search-device-models';
export const SEARCH_DEVICE_INSTRUCTION_ORGANIZATIONS = 'search-device-instruction-organizations';

const selectorPath = selector => selector.selector_kind === 'model'
  ? `models/${selector.device_model_id}`
  : encodeURIComponent(selector.device_type);

export const deviceInstructionActions = {
  searchOrganizations: search => ({
    [API_CALL]: {
      endpoint: 'portal/v1/organizations/',
      method: 'GET',
      params: { search, limit: 50, offset: 0 },
    },
    type: SEARCH_DEVICE_INSTRUCTION_ORGANIZATIONS,
  }),
  searchModels: (search, offset = 0, limit = 100) => ({
    [API_CALL]: {
      endpoint: 'portal/v1/superadmin/iot/device-models',
      method: 'GET',
      params: { search, limit, offset },
    },
    type: SEARCH_DEVICE_MODELS,
  }),
  getConfiguration: (orgId, language) => ({
    [API_CALL]: {
      endpoint: `${root}/configuration/${targetPath(orgId)}`,
      method: 'GET',
      params: { language },
    },
    type: GET_DEVICE_INSTRUCTION_CONFIGURATION,
  }),
  setConfiguration: (orgId, language, selector, objectName, purpose) => ({
    [API_CALL]: {
      endpoint: `${root}/configuration/${targetPath(orgId)}/${selectorPath(selector)}`,
      method: 'PUT',
      params: { language },
      data: { purpose, object_name: objectName },
    },
    type: SET_DEVICE_INSTRUCTION_CONFIGURATION,
  }),
  resetConfiguration: (orgId, language, selector) => ({
    [API_CALL]: {
      endpoint: `${root}/configuration/${targetPath(orgId)}/${selectorPath(selector)}`,
      method: 'DELETE',
      params: { language },
    },
    type: RESET_DEVICE_INSTRUCTION_CONFIGURATION,
  }),
  preview: (orgId, language, selector) => ({
    [API_CALL]: {
      endpoint: `${root}/preview/${targetPath(orgId)}/${selectorPath(selector)}`,
      method: 'GET',
      params: { language },
    },
    type: PREVIEW_DEVICE_INSTRUCTION,
  }),
};
